import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { announcementObject,announcementDetailsListObject } from './announcement.model';

@Injectable({
  providedIn: 'root'
})

export class AnnouncementService {

  constructor(private httpClient: HttpClient,private httpHeaderService: HttpHeadersService) { }

    async getAnnouncements(data:any){
        const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
        let result =  await this.httpClient.post(`${environment.servicePath}/announcement/get_announcements`,data, { headers }).toPromise();
        let preparedAnnouncementDetailsList = this.prepareAnnouncementData(result);
        return preparedAnnouncementDetailsList;
    }

    public prepareAnnouncementData(data: any): announcementObject[] {
        if(!data) return data;
        let announcementsList:announcementObject[] = data.announcementsList;
        announcementsList.forEach(list => {
            list.hasAnnouncementChanged = false;
            list.hasDisplayedOrderChanged = false;
            list.totalAnnouncements = list.announcementDetailsList.length;
            list.duration = list.announcementDetailsList.length<2?'120.0':list.duration;
            list.announcementDetailsList.forEach((announcementDetail:announcementDetailsListObject)=>{
                announcementDetail.id  = announcementDetail.displayOrder?announcementDetail.displayOrder.toString():'1';
                announcementDetail.title = announcementDetail.title?announcementDetail.title:'';
                announcementDetail.message = announcementDetail.message?announcementDetail.message:'';
            })
            if(list.userId !== '0'){
                for (let i = list.announcementDetailsList.length; i < 10; i++) {
                    list.announcementDetailsList.push({id:(i+1).toString(),title:'',message:''} as any);
                }
            }
            
        });
        return announcementsList;
    }

    async postAnnouncement(data:any){
        const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
        const result = await this.httpClient.post(`${environment.servicePath}/announcement/save_announcements`,data, { headers }).toPromise();
        return result;
    }

    async deleteAnnouncement(id:any,console:any){
        const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
        const result = await this.httpClient.delete(environment.servicePath + '/announcement?consoleType='+console+'&announcementId='+id, { headers }).toPromise();
        return result;
    }

    async publishAnnouncement(data:any){
        const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
        const result = await this.httpClient.post(`${environment.servicePath}/announcement/publish_announcements`,data, { headers }).toPromise();
        return result;
    }

}
